import { render, staticRenderFns } from "./EditorV2.vue?vue&type=template&id=398541a9&scoped=true&"
import script from "./EditorV2.vue?vue&type=script&lang=js&"
export * from "./EditorV2.vue?vue&type=script&lang=js&"
import style0 from "./EditorV2.vue?vue&type=style&index=0&id=398541a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398541a9",
  null
  
)

export default component.exports